import { render, staticRenderFns } from "./section-code-create.html?vue&type=template&id=789cb13a&scoped=true&"
import script from "./section-code-create.js?vue&type=script&lang=js&"
export * from "./section-code-create.js?vue&type=script&lang=js&"
import style0 from "./section-code-create.css?vue&type=style&index=0&id=789cb13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789cb13a",
  null
  
)

export default component.exports